"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStakingProgram = exports.getStakingIdl = void 0;
const anchor_1 = require("@project-serum/anchor");
const stakingIdl_1 = require("./../types/stakingIdl");
/**
 * Returns the IDL for the Staking program with provided program ID stored in metadata.
 *
 * @param programId - Deployed program ID for Staking Program
 */
function getStakingIdl(programId) {
    const _tmp = stakingIdl_1.stakingIdl;
    _tmp['metadata']['address'] = programId.toBase58();
    return _tmp;
}
exports.getStakingIdl = getStakingIdl;
/**
 * Get the Staking Program
 *
 * @param connection - the Solana connection object
 * @param programId - Deployed program ID for Staking Program
 */
function getStakingProgram({ connection, programId, }) {
    const idl = getStakingIdl(programId);
    const provider = new anchor_1.AnchorProvider(connection, null, null);
    const program = new anchor_1.Program(idl, programId, provider);
    return program;
}
exports.getStakingProgram = getStakingProgram;
//# sourceMappingURL=getStakingProgram.js.map